<section class="child">
    <nav>
        <c-tree-explorer config="shortcutConfig"></c-tree-explorer>
    </nav>
</section>